module.exports = __webpack_public_path__ + "static/scale-model-of-america's-packard-museum-in-dayton-ohio-21a542e61c32ea65f6dd945d8ec22b7b.png";